export default function itiRegisterDual(itiWrap, options = {}) {
    var visibileInput = $(itiWrap).find(".iti-visible");
    var hiddeInput = $(itiWrap).find(".iti-hidden");

    if ($(visibileInput).length === 0) {
        console.log("Missing visibile iti");
        return null;
    }

    // Preset visibile value in restore
    var initValue = $(hiddeInput).val();
    if (initValue) {
        $(visibileInput).val(initValue);
    }

    // Preset error class in restore
    $(visibileInput).toggleClass("is-invalid", $(hiddeInput).hasClass("is-invalid"));

    // Try preset init country
    var initCountry = ("" + $(visibileInput).data("initCountry")).toLowerCase();
    var isValidInitCountry = initCountry && window.intlTelInputGlobals.getCountryData().some(el => el.iso2 === initCountry);
    if (!isValidInitCountry) {
        console.log("Invalid init country:" + initCountry);
        initCountry = "it";
    }

    var iti = window.intlTelInput(visibileInput[0], {
        initialCountry: initCountry,
        preferredCountries: [],
        nationalMode: true,
        separateDialCode: true,
        autoPlaceholder: false,
        utilsScript: cpAppSet.baseSharedlUrl + "theme/vendors/intl-tel-input/js/utils.js?v=18.2.1",
        formatOnDisplay: false,
        //utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js", // just for formatting/placeholders etc
    });

    function storeUserInput() {
        console.log("Is valid:" + iti.isValidNumber());
        var digit = iti.getNumber(0);//intlTelInputUtils.numberFormat.E164            
        digit = ("" + digit).trim().replace(/\s+/, "");
        if (digit === "" || digit === "+") {
            digit = "";
            $(visibileInput).val("");// Reset also the visibile field
        }
        $(hiddeInput).val(digit);
    }

    $(visibileInput).on("input", function () {
        storeUserInput();
    });

    $(visibileInput).on("countrychange", function () {
        storeUserInput();
    });

    $(visibileInput).closest("form").on("submit", function () {
        storeUserInput();
    });

    return iti;
}
